import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import {
    BidHistory,
    BiddingService,
    GetBidHistory200Response,
} from '@viewbid/ts-angular-client';
import { VbSnackbarService } from '@viewbid/ui';
import { Observable } from 'rxjs';
import { selectUser } from 'src/app/viewbid/state/app-selectors';
import { AppState } from 'src/app/viewbid/state/app-state';
import { User } from 'viewbid-shared-lib';

@Component({
    selector: 'app-bid-history-table',
    templateUrl: './bid-history-table.component.html',
    styleUrls: ['./bid-history-table.component.scss'],
})
export class BidHistoryTableComponent implements OnChanges {
    @Input() auctionLotsId!: string | undefined;
    @Input() showHistory: boolean = false;
    public bidHistory: BidHistory[] = [];
    @Output() hideHistory: EventEmitter<void> = new EventEmitter();
    isLoading: boolean = false;

    user: User | null = null;
    private user$!: Observable<User | null>;

    constructor(
        private store: Store<AppState>,
        private biddingService: BiddingService,
        private snackbarService: VbSnackbarService,
        private translate: TranslateService,
    ) {
        this.user$ = this.store.select<User | null>(selectUser);
        this.user$.subscribe((user: User | null) => {
            this.user = user;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            this.auctionLotsId &&
            changes['showHistory'] &&
            changes['showHistory'].currentValue
        ) {
            this.bidHistory = [];
            this.fetchBidHistory();
        }
    }

    maskUsername(username: string | null | undefined): string {
        if (!username) return '';

        // If length is 1 or 2, just return as is (or decide your own rule)
        if (username.length <= 2) return username;

        const firstChar: string = username[0];
        const lastChar: string = username[username.length - 1];
        const maskedMiddle: string = '*'.repeat(username.length - 2);

        if (this.user?.username.trim() === username.trim()) {
            return username;
        }

        return firstChar + maskedMiddle + lastChar;
    }

    fetchBidHistory(): void {
        if (this.auctionLotsId) {
            this.isLoading = true;
            this.biddingService
                .getBidHistory(this.auctionLotsId, 1, 20)
                .subscribe({
                    next: (response: GetBidHistory200Response) => {
                        this.isLoading = false;
                        this.bidHistory = response.data.map(
                            (item: BidHistory) => ({
                                ...item,
                                bidderName: this.maskUsername(item.bidderName),
                            }),
                        );
                    },
                    error: () => {
                        this.isLoading = false;
                        this.snackbarService.error(
                            this.translate.instant(
                                'Bidding.fetchBidHistoryError',
                            ),
                        );
                        this.hideHistory.emit();
                    },
                });
        }
    }
}
